import { useQuery } from '@tanstack/react-query';

import { globalSearch } from './api';

import type { GlobalSearchResponse } from '@utazzo/shared';

/**
 * Debounced query bound to TanStack. The CommandPalette debounces the
 * input value before passing it through, so by the time `enabledQuery`
 * is set the user has paused typing.
 */
export const useGlobalSearch = (
  enabledQuery: string,
): {
  data: GlobalSearchResponse | undefined;
  isFetching: boolean;
  error: unknown;
} => {
  const trimmed = enabledQuery.trim();
  const enabled = trimmed.length >= 2;
  const q = useQuery({
    queryKey: ['global-search', trimmed],
    queryFn: ({ signal }) => globalSearch(trimmed, { limit: 5, signal }),
    enabled,
    staleTime: 30_000,
    gcTime: 60_000,
  });
  return { data: q.data, isFetching: q.isFetching, error: q.error };
};
